/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useContext } from "react";
import { Accordion, AccordionItem } from "react-light-accordion";
import "react-light-accordion/demo/css/index.css";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";

const Faq = count => {
  const { count: cnt } = count;
  const [length, updateLength] = useState(cnt !== 0 ? cnt : null);
  const { store, StoreAPI } = useContext(StoreContext);
  const [faq, updateFaq] = useState(null);
  const [loading, updateLoading] = useState(true);

  useEffect(() => {
    if (store.loaded) {
      updateLoading(true);
      updateFaq(null);
      StoreAPI.get(`Marketing/faq`)
        .then(response => {
          if (length === null) updateLength(response.data.faQs.length);
          updateFaq(response.data.faQs);
          updateLoading(false);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          updateLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.loaded]);

  return (
    <>
      {loading && <Loading />}
      {faq && (
        <div className="contentPage__faqAccordion">
          <Accordion atomic>
            {faq.slice(0, length).map((item, index) => (
              <React.Fragment key={index}>
                {item.answer && (
                  <AccordionItem id={index} title={item.question}>
                    <p>{item.answer}</p>
                  </AccordionItem>
                )}
              </React.Fragment>
            ))}
          </Accordion>
        </div>
      )}
    </>
  );
};

export default Faq;
